import { Controller } from "@hotwired/stimulus"
import { debug } from "../debug"
import { setupChatQueryHandler } from "../chat_query_handler"

export default class extends Controller {
  static targets = ["iframe"]
  static values = {
    query: String
  }

  connect() {
    debug("Chat query controller connected");
    
    if (this.hasQueryValue && this.queryValue.trim() !== '') {
      debug("Query detected:", this.queryValue);
      this.setupQueryHandler();
    }
  }
  
  setupQueryHandler() {
    if (!this.hasIframeTarget) {
      console.error("No iframe target found");
      return;
    }
    
    // Wait for the iframe to load before setting up the handler
    this.iframeTarget.addEventListener('load', () => {
      debug("Iframe loaded, setting up query handler");
      setupChatQueryHandler(this.iframeTarget, this.queryValue);
    });
  }
}
